var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-poll-people" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("surveys")) + "\n    ")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "questions",
              label: _vm.$t("questions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { attrs: { name: "basic-data", "keep-alive": "" } },
            [_c("basic-data")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "questions", "keep-alive": "" } },
            [_c("questions")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }